import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchMediaInTheNews } from "Thunks";
import { TTP_API_URL } from "Config";
import Slider from "react-slick";

class Media extends Component {
  componentDidMount() {
    const { fetchMediaInTheNews } = this.props;

    fetchMediaInTheNews();
  }

  render() {
    const { medias } = this.props;

    if (!medias) {
      return (
        <div className="media-caroussel cell small-6 medium-8">
          <div
            style={{
              backgroundImage: "url(/img/default_com.jpg)",
              backgroundSize: "contain",
              width: "100%",
              height: "15rem"
            }}
          />
        </div>
      );
    }
    let hide = medias.length === 1 ? "hide" : "";

    var settings = {
      dots: true,
      dotsClass: "slick-dots " + hide,
      infinite: true,
      arrows: false,
      speed: 1000,
      autoplay: true,
      key: 11
    };

    let imgDivs = (medias || []).map(media => (
      <div
        key={`med-${media.id}`}
        style={{
          backgroundImage: `url(${
            media.fullMediaUrl
              ? media.fullMediaUrl
              : `${TTP_API_URL}/${media.webPath}`
          })`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          width: "100%",
          minHeight: "18rem"
        }}
      />
    ));

    return (
      <div className="media-caroussel cell small-6 medium-8">
        {imgDivs.length > 0 ? <Slider {...settings}>{imgDivs}</Slider> : null}
      </div>
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  medias: state.medias.items
});

const mapDispatchToProps = dispatch => ({
  fetchMediaInTheNews: () => dispatch(fetchMediaInTheNews())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Media);



// WEBPACK FOOTER //
// ./src/components/PublicPortal/Media.js